module.exports = __webpack_public_path__ + "static/media/editSvg.3b7512f5.svg";